var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",class:{'info': _vm.type == 'info'}},[_c('b-img',{attrs:{"src":require('@/assets/' + _vm.icon + '')}}),_c('p',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }